<script setup lang="ts">
	import { ref, onMounted, onUnmounted } from 'vue';

	interface ConfirmExitGuardProps {
		confirmExitMessage?: string;
	}

	const props = defineProps<ConfirmExitGuardProps>();

	interface FormDirtyStateDetail {
		isDirty: boolean;
	}

	const internalIsDirty = ref<boolean>(false);

	const handleBeforeUnload = (event: BeforeUnloadEvent) => {
		if (internalIsDirty.value) {
			const message = props.confirmExitMessage;
			event.preventDefault();
			event.returnValue = message;
			return message;
		}
	};

	const handleFormDirtyStateChanged = (event: Event) => {
		if (event instanceof CustomEvent && typeof event.detail === 'object' && 'isDirty' in event.detail) {
			const detail = event.detail as FormDirtyStateDetail;
			internalIsDirty.value = detail.isDirty;
		}
	};

	onMounted(() => {
		window.addEventListener('beforeunload', handleBeforeUnload);
		document.addEventListener('activateabandonmentmodal', handleFormDirtyStateChanged as EventListener);
	});

	onUnmounted(() => {
		window.removeEventListener('beforeunload', handleBeforeUnload);
		document.removeEventListener('activateabandonmentmodal', handleFormDirtyStateChanged as EventListener);
	});
</script>

<template>
  <slot></slot>
</template>
